import { memo } from 'react';
import { Ban } from 'lucide-react';

export const DeletedMessagePlaceholder = memo(function DeletedMessagePlaceholder() {
  return (
    <div className="flex items-center gap-2 text-muted-foreground">
      <Ban className="size-3.5" aria-hidden="true" />
      <span className="text-sm italic">This message was deleted</span>
    </div>
  );
});
